import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { ForeigntransferComponent } from './foreign-transfer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, JsonpModule } from '@angular/http';

const routes: Routes = [{
	path: '',
	data: {
      title: 'Foreign Exchange Transfer Process',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Foreign Exchange Transfer'}]
    },
	component: ForeigntransferComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule,
		HttpModule,
        JsonpModule,
        NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [ForeigntransferComponent]
})
export class ForeigntransferModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/school/foreign-transfer/foreign-transfer.module.ts